export default function (context, val) {
  let settings = context.rootState.user.setting.items;
  context.dispatch('set_title', 'Добавление требования', {root: true});
  context.commit('set_load', {
    data: false,
  });
  let date = new Date();
  let category = context.rootGetters['dictionary/paymentType/getById'](settings.DefaultRegularPaymentType).CategoryId;
  let cash = settings.DefaultRegularPaymentSource;
  let account = settings.DefaultRegularPaymentSource;
  switch (category) {
    case 0:
      if (!context.rootState.dictionary.cash.list.filter(i => i.value === cash)[0]) {
        if (context.rootState.dictionary.cash.list[0]) cash = context.rootState.dictionary.cash.list[0].value;
      }
      break;
    case 1:
      if (!context.rootState.dictionary.paymentAccount.list.filter(i => i.value === account)[0]) {
        if (context.rootState.dictionary.paymentAccount.list[0]) account = context.rootState.dictionary.paymentAccount.list[0].value;
      }
      break;
  }
  context.commit('set_form', {
    Id: 0,
    CertificateId: '',
    CertificateName: '',
    Name: '',
    NameLat: '',
    PaymentDirection: 1,
    PaymentOperationID: settings.DefaultRegularPaymentOperation,
    RateArticleId: null,
    CategoryId: category,
    PaymentTypeId: settings.DefaultRegularPaymentType,
    CashId: cash,
    PaymentAccountId: account,
    AccountNumber: '',
    ContragentType: context.rootGetters['dictionary/contragentType/list'](settings.DefaultRegularPaymentOperation)[0].value,
    ContragentID: null,
    ContragentName: '',
    PartnerLegalEntityId: null,
    Sum: 0,
    CurrencyId: 1,
    PaymentDate: '',
    DocumentNumber: context.state.system.OutcomePaymentNumber,
    Comment: '',
    RegularPaymentTypeId: 4,
    dayMonth: 1,
    dayWeek: 1,
    dayYear: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    dayOne: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    NotificationsEndDate: '',
    AgreementCodes: [],
  });
  context.dispatch('invoices/get', {
    id: val.id,
    callback: (invoice) => {
      context.commit('set_form', invoice.form);
      context.state.options.legals = invoice.legals;
      context.dispatch('agreement_comment');
      context.commit('set_load', {
        data: false,
      });
    }
  });
}
